import * as React from 'react';

import BaseIcon from 'shared/newComponents/icons/BaseIcon';
import { CommonIconProps, IconSize } from 'shared/entities/components/Icon';

const ReturnIcon: React.FC<CommonIconProps> = (props: CommonIconProps) => {
  return (
    <BaseIcon
      iconSize={IconSize.L}
      svgProps={{
        viewBox: '0 0 24 24'
      }}
      {...props}
    >
      <path
        d="M5.636 18.3639C7.10845 19.8364 9.04594 20.7527 11.1183 20.9567C13.1906 21.1607 15.2696 20.6398 17.0009 19.4827C18.7322 18.3256 20.0087 16.604 20.6129 14.6112C21.217 12.6184 21.1115 10.4778 20.3142 8.55408C19.5169 6.63039 18.0772 5.0427 16.2404 4.06158C14.4037 3.08045 12.2835 2.7666 10.2413 3.17352C8.19909 3.58043 6.36116 4.68293 5.04073 6.29312C3.72031 7.90332 2.99909 9.92157 3 12.0039V13.9999"
        strokeWidth="2"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1 12L3 14L5 12"
        strokeWidth="2"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </BaseIcon>
  );
};

export default ReturnIcon;
